import React from 'react';
import { HelpCircle } from 'lucide-react';

const TutorialButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
      aria-label="Help - Replay Tutorial"
      title="Help - Replay Tutorial"
    >
      <HelpCircle className="h-5 w-5 text-gray-600" />
    </button>
  );
};

export default TutorialButton;
